import { DFVariableCharges } from 'app/df-management/shared/df-master-data.model';

export class TransactionData {

    public id?: string;
    public action: TransactionDataAction;
    public countryCode?: string;
    public carrierCode?: number;
    public assetId?: string;
    public assetType?: string;
    public status?: string;
    public loadId?: string;
    public deliveryId?: string;
    public voucherId?: string;
    public actualPickupDate?: string;
    public loadStartDate?: string;
    public loadEndDate?: string;
    public pieces?: string;
    public podDate?: string;
    public pgiDate?: string;
    public podStatus?: string;
    public originId?: string;
    public destinationId?: string;
    public distanceTravel?: string;
    public distanceUnit?: string;
    public chargeType?: string;
    public orderType?: string;
    public rentCharges?: string;
    public labourCharges?: string;
    public extraDistanceCharges?: string;
    public fuelCharges?: string;
    public tollCharges?: string;
    public otherCharges?: string;
    public emptyMiles?: string;
    public loadedMiles?: string;
    public btfStatus?: BtfExportStatus;
    public btfStatusMessage?: string;
    public totalCharges?: string;
    public currency?: string;
    public serviceId?: string
    public createdBy?: string;
    public updatedBy?: string;
    public createdDate?: string;
    public updatedDate?: string;
    public byStatusCode?: string;
    public byStatusMessage?: string;
    public charges?: DFVariableCharges[];
    public fmStatusCode?: string;
    public loadStatus: string;
    public loadStatusShortform: string;
    public updatedTotalChargesNote: string;
    public isCheckboxSelected?: boolean;
    public selected = false;
    public loadingCharges?: DFLoadingCharges[];

    static fromDto(r) {
      if (!r) {
        return null;
      }
        const transactionData           = new TransactionData();
        transactionData.id = r?.id;
        transactionData.countryCode = r?.country_code;
        transactionData.carrierCode = r?.carrier_code;
        transactionData.assetId = r?.asset_id;
        transactionData.assetType = r?.asset_type;
        transactionData.status = r?.status;
        transactionData.loadId = r?.load_id;
        transactionData.deliveryId = r?.delivery_id;
        transactionData.voucherId = r?.voucher_id;
        transactionData.actualPickupDate = r?.actual_pickup_date;
        transactionData.loadStartDate = r?.load_start_date;
        transactionData.loadEndDate = r?.load_end_date;
        transactionData.pieces = r?.pieces;
        transactionData.podDate = r?.pod_date;
        transactionData.pgiDate = r?.pgi_date;
        transactionData.podStatus = r?.pod_status;
        transactionData.originId = r?.origin_id;
        transactionData.destinationId = r?.destination_id;
        transactionData.distanceTravel = r?.distance_travel;
        transactionData.distanceUnit = r?.distance_unit;
        transactionData.chargeType = r?.charge_type;
        transactionData.orderType = r?.order_type;
        transactionData.rentCharges = r?.rent_charges;
        transactionData.labourCharges = r?.labour_charges;
        transactionData.extraDistanceCharges = r?.extra_distance_charges;
        transactionData.fuelCharges = r?.fuel_charges;
        transactionData.tollCharges = r?.toll_charges;
        transactionData.otherCharges = r?.other_charges;
        transactionData.emptyMiles = r?.empty_miles;
        transactionData.loadedMiles = r?.loaded_miles;
        transactionData.btfStatus = r?.btf_status;
        transactionData.btfStatusMessage = r?.btf_status_message;
        transactionData.totalCharges = r?.total_charges;
        transactionData.currency = r?.currency;
        transactionData.serviceId = r?.service_id;
        transactionData.createdBy = r?.created_by;
        transactionData.updatedBy = r?.updated_by;
        transactionData.createdDate = r?.created_date;
        transactionData.updatedDate = r?.updated_date;
        transactionData.byStatusCode = r?.by_status_code;
        transactionData.byStatusMessage = r?.by_status_message;
        transactionData.charges = r?.charges;
        transactionData.fmStatusCode = r?.fm_status_code;
        transactionData.loadStatus = r?.load_status;
        transactionData.loadStatusShortform = r?.load_status_short_form;
        transactionData.updatedTotalChargesNote = r?.updated_total_charges_note;
        transactionData.loadingCharges = r?.loadingCharges;

        return transactionData;
      }

      static toDto(r: TransactionData): any {
        if (!r) {
          return null;
        }

        return {
          id: r.id,
          action: r.action,
          country_code: r.countryCode,
          carrier_code: r.carrierCode,
          asset_id: r.assetId,
          asset_type: r.assetType,
          status: r.status,
          load_id: r.loadId,
          delivery_id: r.deliveryId,
          voucher_id: r.voucherId,
          actual_pickup_date: r.actualPickupDate,
          load_start_date: r.loadStartDate,
          load_end_date: r.loadEndDate,
          pieces: r.pieces,
          pod_date: r.podDate,
          pgi_date: r.pgiDate,
          pod_status: r.podStatus,
          origin_id: r.originId,
          destination_id: r.destinationId,
          distance_travel: r.distanceTravel,
          distance_unit: r.distanceUnit,
          charge_type: r.chargeType,
          extra_distance_charges: r.extraDistanceCharges,
          service_id: r.serviceId,
          currency: r.currency,
          created_by: r.createdBy,
          updated_by: r.updatedBy,
          created_date: r.createdDate,
          updated_date: r.updatedDate,
          rent_charges: r.rentCharges,
          loadingCharges: r.loadingCharges,
          charges: r.charges,
          total_charges: r.totalCharges,
          empty_miles: r.emptyMiles,
          loaded_miles: r.loadedMiles,
          updated_total_charges_note: r.updatedTotalChargesNote
        };
      }
}


export class DFLoadingCharges {
  id: string;
  asset_id: string;
  carrier_code: string;
  charge_amount: string;
  charge_code: string;
  charge_type: string;
  country_code: string;
  currency: string;
  load_id: string;
  status: string;
}



export class Summary extends TransactionData {
  public summary: DFSummary;
}

export class DFLoadResults extends TransactionData {
  public results: DFLoad;
}

export class DFStatus  {
  public id?: string;
  public status?: string;
  public statusShortForm?: string;

  static fromDto(r) {
    if (!r) {
      return null;
    }
      const dfstatus           = new DFStatus();
      dfstatus.id = r.id;
      dfstatus.status = r.status;
      dfstatus.statusShortForm = r.status_short_form;
      return dfstatus

  }

  static toDto(r: DFStatus): any {
    if (!r) {
      return null;
    }

    return {
      id:  r.id,
      status: r.status,
      status_short_form: r.statusShortForm
    }
  }
}

export class DFLoad {
  id?: string;
  countryCode?: string;
  carrierCode?: number;
  assetId?: string;
  assetType?: string;
  status?: string;
  btfStatus?: string;
  loadId?: string;
  deliveryId?: string;
  voucherId?: string;
  actualPickupDate?: string;
  loadStartDate?: string;
  loadEndDate?: string;
  pieces?: string;
  podDate?: string;
  pgiDate?: string;
  podStatus?: string;
  originId?: string;
  destinationId?: string;
  distanceTravel?: string;
  distanceUnit?: string;
  chargeType?: string;
  orderType?: string;
  rentCharges?: string;
  labourCharges?: string;
  extraDistanceCharges?: string;
  fuelCharges?: string;
  tollCharges?: string;
  otherCharges?: string;
  totalCharges?: string;
  emptyMiles?: string;
  loadedMiles?: string;
  currency?: string;
  serviceId?: string
  createdBy?: string;
  updatedBy?: string;
  createdDate?: string;
  updatedDate?: string;
  byStatusCode?: string;
  byStatusMessage?: string;
  charges?: DFVariableCharges[];
  fmStatusCode?: string;
  loadStatus: string;
  loadStatusShortform: string;
  isSelected?: boolean;
  updatedTotalChargesNote?: string;
  loadingCharges?: DFLoadingCharges[];
}

export class DFSummary {
  No_Of_Loads: string;
  Updated_by_System: string;
  Users_Count: string;
  Failures: string;
}

export class DFStatusCount {
  Auto_Calculated_Count: number;
  Total_Loads_Count: number;
  Success_Count: number;
  Unproccessed_Count: number;
  Created_Count: number;
  Failure_Count: number;
  Mnually_calculated_count: number;
  No_active_contract_count: number;
  Not_eligible_count: number;


  static fromDto(r) {
    if (!r) {
      return null;
    }
      const DfStatusCount           = new DFStatusCount();
      DfStatusCount.Auto_Calculated_Count = r.auto_calculated_count;
      DfStatusCount.Total_Loads_Count = r.total_loads_count;
      DfStatusCount.Success_Count = r.success_count;
      DfStatusCount.Unproccessed_Count = r.unproccessed_count;
      DfStatusCount.Created_Count = r.created_count;
      DfStatusCount.Failure_Count = r.failure_count;
      DfStatusCount.Mnually_calculated_count = r.manually_calculated_count;
      DfStatusCount.No_active_contract_count = r.no_active_contract_count;
      DfStatusCount.Not_eligible_count = r.not_eligible_count;


      return DfStatusCount
  }

  static toDto(r: DFStatusCount): any {
    if (!r) {
      return null;
    }

    return {
      auto_calculated_count:  r.Auto_Calculated_Count,
      total_loads_count: r.Total_Loads_Count,
      success_count: r.Success_Count,
      unproccessed_count: r.Unproccessed_Count,
      created_count: r.Created_Count,
      failure_count: r.Failure_Count,
      manually_calculated_count: r.Mnually_calculated_count,
      no_active_contract_count: r.No_active_contract_count,
      not_eligible_count: r.Not_eligible_count

    }
  }
}

export class MyDFStatusCountList {
  Load_Search_Count: number;
  Carrier_Search_Count: number;
  Asset_Search_Count: number;
  Voucher_Update_Job_Count: number;
  Auto_Calculation_Job_Count: number;
  Total_Jobs_Count: number;

  static fromDto(r) {
    if (!r) {
      return null;
    }
      const DFStatusCountList           = new MyDFStatusCountList();
      DFStatusCountList.Load_Search_Count = r.load_search_count;
      DFStatusCountList.Carrier_Search_Count = r.carrier_search_count;
      DFStatusCountList.Asset_Search_Count = r.asset_search_count;
      DFStatusCountList.Voucher_Update_Job_Count = r.voucher_update_job_count;
      DFStatusCountList.Auto_Calculation_Job_Count = r.auto_calculation_job_count;
      DFStatusCountList.Total_Jobs_Count = r.total_jobs_count;
      return DFStatusCountList
  }

  static toDto(r: MyDFStatusCountList): any {
    if (!r) {
      return null;
    }

    return {
      load_search_count:  r.Load_Search_Count,
      carrier_search_count: r.Carrier_Search_Count,
      asset_search_count: r.Asset_Search_Count,
      voucher_update_job_count: r.Voucher_Update_Job_Count,
      auto_calculation_job_count: r.Auto_Calculation_Job_Count,
      total_jobs_count: r.Total_Jobs_Count

    }
  }
}

export enum LoadStatus {
  X = 'X',
  MC = 'MC',
  F = 'F',
  UL = 'UL',
  S = 'S',
  NC = 'NC',
  NE = 'NE'
}

export enum BtfExportStatus {
  PENDING = 'PENDING',
  DONE = 'DONE'
}

export enum TransactionDataAction {
  SAVE = 'SAVE',
  SUBMIT = 'SUBMIT',
}
